import styled from 'styled-components';
import { StyleSheet } from '@react-pdf/renderer';

export const CalendarButton = styled.button`
  color: #fff;
  margin: 2rem 0 0;
  font-size: 16px;
  line-height: 20px;
  -webkit-letter-spacing: 1.29px;
  -moz-letter-spacing: 1.29px;
  -ms-letter-spacing: 1.29px;
  letter-spacing: 1.29px;
  font-family: ${({ dir }) => (dir === 'rtl' ? 'GESSTwoDWTCLight' : 'DINRegular')} sans-serif;
`;

export const enStyles = StyleSheet.create({
  view: {
    width: '100vw',
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    margin: 0,
  },
  page: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    margin: 0,
  },
  body: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    margin: 0,
    rowGap: 12,
    paddingTop: 36,
    paddingBottom: 36,
  },
  headerImg: {
    width: '13%',
    height: 'auto',
    objectFit: 'contain',
    position: 'absolute',
    top: 15,
    right: 42,
    zIndex: 10,
  },
  header: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    backgroundColor: '#0070CF',
    paddingLeft: 56,
    paddingTop: 36,
    paddingBottom: 36,
    position: 'relative',
    marginTop: -36,
  },
  headerArrow: {
    width: 56,
    height: 56,
    objectFit: 'contain',
    position: 'absolute',
    display: 'block',
    top: 22,
    left: -30,
    transform: 'rotate(45deg)',
    borderRight: '5px solid #FFFFFF',
    borderTop: '5px solid #FFFFFF',
    zIndex: 15,
  },
  titleContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
  },
  title: {
    fontSize: 20,
    textAlign: 'left',
    width: '100%',
    lineHeight: 1.5,
    color: '#FFFFFF',
    fontFamily: 'SegoeUI',
    textTransform: 'uppercase',
    margin: 0,
    fontWeight: 700,
  },
  subtitle: {
    fontSize: 10,
    textAlign: 'left',
    width: '100%',
    lineHeight: 1.5,
    color: '#FFFFFF',
    fontFamily: 'SegoeUI',
    margin: 0,
    fontWeight: 700,
  },
  container: {
    width: '100%',
    height: 'auto',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    paddingRight: 36,
    paddingLeft: 42,
    paddingBottom: 2,
    paddingTop: 16,
    margin: 0,
    rowGap: 4,
  },
  monthTitle: {
    fontSize: 16,
    textAlign: 'left',
    width: '100%',
    lineHeight: 1.5,
    color: '#0070CF',
    fontFamily: 'SegoeUI',
    fontWeight: 700,
    textTransform: 'uppercase',
    borderBottom: '1px solid #0070CF',
    marginBottom: 8,
    paddingBottom: 8,
  },
  date: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: 'auto',
    height: 'auto',
    rowGap: 2,
  },
  dateNumberText: {
    fontSize: 12,
    fontFamily: 'SegoeUI',
    fontWeight: 600,
    fontStyle: 'mono',
    color: '#000000',
  },
  dateMonthText: {
    fontSize: 9,
    fontFamily: 'SegoeUI',
    fontStyle: 'mono',
    fontWeight: 400,
    color: '#7F7E7E',
    textTransform: 'uppercase',
  },
  eventContainer: {
    width: '100%',
    height: 'auto',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    flexWrap: 'nowrap',
  },
  dateContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: 'auto',
    height: 'auto',
    margin: 0,
    padding: 0,
    columnGap: 32,
  },
  eventInfoContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    width: '65%',
    height: 'auto',
    flexGrow: 1,
    paddingLeft: 42,
    textDecoration: 'none',
  },
  eventTitle: {
    fontFamily: 'SegoeUI',
    fontSize: 12,
    fontWeight: 'normal',
    fontStyle: 'normal',
    color: '#000000',
    paddingRight: 24,
    textDecoration: 'none',
  },
  eventTags: {
    fontSize: 9,
    fontFamily: 'SegoeUI',
    fontStyle: 'normal',
    fontWeight: 400,
    color: '#7F7E7E',
  },
  eventWebsite: {
    fontFamily: 'SegoeUI',
    fontSize: 8,
    fontWeight: 'bold',
    fontStyle: 'normal',
    color: '#0070CF',
    wordBreak: 'break-all',
    overflowWrap: 'anywhere',
    whiteSpace: 'pre-line',
    maxWidth: '30%',
    textDecoration: 'none',
  },
  eventWebsiteLink: {
    textDecoration: 'none',
  },
  footerContainer: {
    width: '55%',
    height: 'auto',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    columnGap: 16,
    paddingRight: 36,
    paddingLeft: 42,
  },
  footerText: {
    height: 'auto',
    textAlign: 'left',
    fontSize: 10,
    fontFamily: 'SegoeUI',
    fontStyle: 'normal',
    fontWeight: 'thin',
    color: '#000000',
    textDecoration: 'none',
  },
  disclaimer: {
    width: '100%',
    textAlign: 'center',
    fontSize: 10,
    fontFamily: 'SegoeUI',
    fontStyle: 'normal',
    fontWeight: 'thin',
    color: '#000000',
    paddingRight: 42,
    paddingLeft: 36,
  },
});

export const arStyles = StyleSheet.create({
  view: {
    width: '100vw',
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    margin: 0,
  },
  page: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    margin: 0,
  },
  body: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    margin: 0,
    rowGap: 12,
    paddingTop: 36,
    paddingBottom: 36,
  },
  headerImg: {
    width: '13%',
    height: 'auto',
    objectFit: 'contain',
    position: 'absolute',
    top: 15,
    left: 42,
    zIndex: 10,
  },
  header: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row-reverse',
    justifyContent: 'flex-start',
    alignItems: 'center',
    backgroundColor: '#0070CF',
    paddingRight: 56,
    paddingTop: 36,
    paddingBottom: 36,
    position: 'relative',
    marginTop: -36,
  },
  headerArrow: {
    width: 56,
    height: 56,
    objectFit: 'contain',
    position: 'absolute',
    display: 'block',
    top: 22,
    right: -30,
    transform: 'rotate(45deg)',
    borderLeft: '5px solid #FFFFFF',
    borderBottom: '5px solid #FFFFFF',
    zIndex: 15,
  },
  titleContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
  },
  title: {
    fontSize: 20,
    textAlign: 'right',
    width: '100%',
    lineHeight: 1.5,
    color: '#FFFFFF',
    fontFamily: 'GESSTwo',
    textTransform: 'uppercase',
    margin: 0,
    fontWeight: 700,
  },
  subtitle: {
    fontSize: 10,
    textAlign: 'right',
    width: '100%',
    lineHeight: 1.5,
    color: '#FFFFFF',
    fontFamily: 'GESSTwo',
    margin: 0,
    fontWeight: 700,
  },
  container: {
    width: '100%',
    height: 'auto',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    paddingRight: 36,
    paddingLeft: 42,
    paddingBottom: 2,
    paddingTop: 16,
    margin: 0,
    rowGap: 5,
  },
  disclaimer: {
    width: '100%',
    textAlign: 'center',
    fontSize: 10,
    fontFamily: 'GESSTwo',
    fontStyle: 'normal',
    fontWeight: 'thin',
    color: '#000000',
    paddingRight: 36,
    paddingLeft: 42,
  },
  monthTitle: {
    fontSize: 16,
    textAlign: 'right',
    width: '100%',
    lineHeight: 1.5,
    color: '#0070CF',
    fontFamily: 'GEAwtarDWTCMedium',
    textTransform: 'uppercase',
    borderBottom: '1px solid #0070CF',
    marginBottom: 8,
    paddingBottom: 2,
  },
  date: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: 'auto',
    rowGap: 4,
    width: 28,
  },
  dateNumberText: {
    fontSize: 10,
    family: 'DejaVuSansMono',
    fontWeight: 'bold',
    fontStyle: 'mono',
    color: '#000000',
  },
  dateMonthText: {
    fontSize: 6,
    fontFamily: 'GESSTwo',
    fontWeight: 'thin',
    color: '#7F7E7E',
    textTransform: 'uppercase',
  },
  eventContainer: {
    width: '100%',
    height: 'auto',
    display: 'flex',
    flexDirection: 'row-reverse',
    justifyContent: 'flex-start',
    alignItems: 'center',
    flexWrap: 'nowrap',
  },
  dateContainer: {
    display: 'flex',
    flexDirection: 'row-reverse',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: 'auto',
    height: 'auto',
    margin: 0,
    padding: 0,
    columnGap: 24,
  },
  eventInfoContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-end',
    width: 'auto',
    height: 'auto',
    flexGrow: 1,
    paddingRight: 42,
  },
  eventInfoTitleContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-end',
    height: 'auto',
    textDecoration: 'none',
  },
  eventTitle: {
    fontFamily: 'GEAwtarDWTCMedium',
    fontSize: 12,
    color: '#000000',
    textAlign: 'right',
    display: 'flex',
    flexDirection: 'row-reverse',
    flexWrap: 'wrap',
    textDecoration: 'none',
  },
  eventTags: {
    fontSize: 6,
    fontFamily: 'GESSTwo',
    fontWeight: 'thin',
    color: '#7F7E7E',
  },
  eventWebsite: {
    fontFamily: 'SegoeUI',
    fontSize: 8,
    fontWeight: 'bold',
    fontStyle: 'normal',
    color: '#0070CF',
    wordBreak: 'break-all',
    overflowWrap: 'anywhere',
    whiteSpace: 'pre-line',
    maxWidth: '30%',
    textDecoration: 'none',
  },
  eventWebsiteLink: {
    textDecoration: 'none',
  },
  footerContainer: {
    width: '55%',
    height: 'auto',
    display: 'flex',
    flexDirection: 'row-reverse',
    justifyContent: 'space-between',
    alignItems: 'center',
    columnGap: 16,
    paddingRight: 36,
    paddingLeft: 42,
  },
  footerText: {
    height: 'auto',
    textAlign: 'center',
    fontSize: 10,
    fontFamily: 'GESSTwo',
    fontStyle: 'normal',
    fontWeight: 'thin',
    color: '#000000',
    textDecoration: 'none',
  },
});
